export default "__VITE_ASSET__tDeolKdE__"